import React, { Component, Fragment } from "react";
import { Col, Row, Button } from "react-bootstrap";
import ReactTable from "react-table";
import debounce from "lodash/debounce";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import ExportService from "../../../services/ExportService";
import LogsService from "../../../services/LogsService"; 
import HandleError from "../../../services/HandleError";
import DeleteModal from "../../modals/DeleteModal";
import EditLoggedHoursModal from "../../modals/EditLoggedHoursModal";
import Materialicon from "../../helpers/Materialicon";
import { minutesToHourAndMinutes, hoursToMinutes, dataToSelectOption } from "../../helpers/HelperFunctions";
import { hasPermission } from "../../helpers/Permissions";

class MyLogsPage extends Component {
	state = {
		logToDelete: null,
		selectedTask: null,
		isDeleting: false,
		isEditingHours: false,
		isLoadingTable: true,
		showEditModal: false,
		selectedArea: null,
    	selectedProject: null,
		selectedLogType: null,
		status_id: null,
		projectName: "",		
		directTask: false,
		minutes: null,
    	hours: "",
		data: [],
		formData: {},
    	errors: {},	
		pages: 1,
	}

	onChange = (e) => { this.setState({ formData: { ...this.state.formData, [e.target.name]: e.target.value } }); };
	
	onChangeHours = (e) => {
		if(e.target.value !== "") {
			this.setState({ ...this.state, hours: parseInt(e.target.value,0,10) });
		} else {
			this.setState({  ...this.state, hours: 0 });
		}
	}

	onSelectChange = (option, name, selected)  => {
		if (option !== null) {
			this.setState({ [selected]: option, formData: { ...this.state.formData, [name]: option.value || "" }});
		} else {
			this.setState({ [selected]: null, formData: { ...this.state.formData, [name]: null } });
		}
	}

	onMinutesSelectChange = (option) => {
		if (option !== null) {
			this.setState({  ...this.state, minutes: option });
		} else {
			this.setState({ ...this.state, minutes: null });
		}
	}

	onUpdateSubmit = (e) => {
		const hours = hoursToMinutes(this.state.hours);
		const minutes = this.state.minutes ? this.state.minutes.value : 0;
		this.setState({
			...this.state,
			isEditingHours: true, 
			formData: { ...this.state.formData, time: (hours+minutes).toString() }
		}, () => {
			new LogsService(this).update(this.state.editId, this.state.formData).then((res) => {
				this.setState({
					isEditingHours: false, 
					showEditModal: false,
					selectedTask: null,
					minutes: null,
					editId: null, 
					hours: 0,
					formData: {},
					errors: {},
				});
				NotificationManager.success("Log Updated.", "Success!");
			}).catch((err) => {
				this.setState({ isEditingHours: false });
				HandleError(err, this);
			}).then(() => {
				this.getMyLogs(this.state.pageState);
			});
		});
	}

	getMyLogs= (state) => {
		const {pageSize, sorted, filtered, page } = state;
		const data = JSON.stringify({pageSize, sorted, filtered});
		this.setState({ isLoadingTable: true});
		new LogsService(this,"/my-logs").index(page+1, `data=${data}`).then((res) => {
			this.setState({ isLoadingTable:false, data: res.data.data, pages: res.data.last_page, pageState: state });
		}).catch((err) => {
			this.setState({isLoadingTable:false});
			HandleError(err,this);
		});
	}

	getLogTypes = () => {
		const logTypes = [
			{value: 1, label: "Normal hours"},
			{value: 2, label: "Extra hours"},
			{value: 3, label: "Replacement hours"},
			{value: 4, label: "Other" }
		];
		return logTypes;
	}

	handleEditLog = (loggedItem) => {
		if(loggedItem) {
			const { hours, minutes } = minutesToHourAndMinutes(loggedItem.time || null);
			const progress = this.findTaskProgress(loggedItem.task_id);
			this.setState({
				showEditModal: true,
				editId: loggedItem.id || null,
				selectedLogType: dataToSelectOption(loggedItem.log_type_id,"value", loggedItem.log_type_name,"label"),
				directTask: !!parseInt(loggedItem.is_directly_logged, 0, 10),
				status_id: loggedItem.status_id || "",
				projectName: loggedItem.project_name || "",
				progress,
				hours,
				minutes: dataToSelectOption(minutes,"value", minutes.toString(),"label"),
				formData: {
					logged_at: loggedItem.logged_at,
					task_id: loggedItem.task_id,
					description: loggedItem.description,
					directTask: !!parseInt(loggedItem.is_directly_logged, 0, 10),
					log_type_id: loggedItem.log_type_id,
					name: loggedItem.title
				},
			});
			if(loggedItem.is_directly_logged) {
				this.setState({
					selectedProject: dataToSelectOption(loggedItem.project_id,"value", loggedItem.project_name,"label"),
					selectedArea: dataToSelectOption(loggedItem.area_id,"value", loggedItem.area_name,"label"),
				});
			} else {
				this.setState({ selectedTask: dataToSelectOption(loggedItem.task_id,"value", loggedItem.title,"label") });
			}
		} else {
			this.closeEditModal();
		}
	}

	findTaskProgress = (taskId) => {
		const { tasks } = this.state;
		if(taskId && tasks && Array.isArray(tasks)) {
			const task = tasks.find((item) => (item.value && item.value === taskId));
			if(task) {
				return parseFloat(task.task_progress);
			}
			return 100; // task is directly logged and the progress is always 100%
		}
		return null;
	}

	logToDelete = (loggedHour) => {
		this.setState({ logToDelete : {name: loggedHour.title, id: loggedHour.id} });
	}
	
	deleteLog = () => {
		if(this.state.logToDelete) {
			this.setState({ isDeleting: true });
			new LogsService(this).delete(this.state.logToDelete.id).then((res) => {
				this.setState({ isDeleting: false });
				NotificationManager.success("Log deleted.", "Success!");
			}).catch((err) => {
				this.setState({ isDeleting: false });
				HandleError(err, this);
			}).then(() => {	
				this.getMyLogs(this.state.pageState);		
				this.closeModal();
			});
		}
	}

	exportToExcel = () => {
		const exportService = new ExportService();
		const state = this.state.pageState;
		const page = this.state.pageState.page + 1;
		const data = JSON.stringify({
			pageSize: state.pageSize,
			sorted: state.sorted,
			filtered: state.filtered
		});
		exportService.exportToExcel("admin/export-logged-hours", page, data);
	}

	closeModal = () => {
		this.setState({
			logToDelete: null,
			isDeleting: false,
		});
	}

	closeEditModal = () => {
		this.setState({
			...this.state,
			showEditModal: false,
			selectedTask: null,
			selectedProject: null,
			selectedArea: null,
			directTask: false,
			editId: null,
			minutes:null,
			errors: {},
			formData: {},
			hours:0,
		});
	}

	render() {
		const { 
			isDeleting, isEditingHours, isLoadingTable, showEditModal, selectedLogType, selectedTask, selectedArea, selectedProject, directTask,
			minutes, hours, formData, errors, data, pages, logToDelete, projectName, status_id
		} = this.state;
		const canExport = hasPermission("export.logs");
		const logTypes = this.getLogTypes();
    	return (
    		<div className="crud-page my-logs-page">
    			<div className="container-fluid">
    				<section className="actions">
    					<Row>
    						<Col md={6} sm={6} xs={12}>
    							<h2 className="page-title">My logs</h2>
    						</Col>
    						<Col md={6} sm={6} xs={12} />
    					</Row>   
    				</section>
    				<div className="card card-top-border connection-card fadeInLoadUp">
						{	canExport &&
							<Row>
								<Col md={12}>
									<Button bsStyle="primary" className="btn-min btn-crud btn-export" onClick={this.exportToExcel}>Export</Button>
								</Col>
							</Row>
						}
    					<ReactTable
    						columns={[
    							{
    								Header: "Employee",
    								accessor: "assigned_name",
									Cell: row => <div className="text-center">{row.value}</div>,
									minWidth: 150
    							}, {
    								Header: "Task",
    								accessor: "title",
									Cell: row => <div className="text-center">{row.value}</div>,
									minWidth: 200
    							},{
    								Header: "Project",
    								accessor: "project_name",
									Cell: row => <div className="text-center">{row.value}</div>,
									minWidth: 200
    							}, 
    							{	
    								Header: "Time",
    								accessor: "time",
									Cell(row) {
										const time = minutesToHourAndMinutes(row.value);
										return (<div className="text-center">{time.hours}h { time.minutes > 0 ? ` and ${time.minutes}min` : null}</div>);
									},
									minWidth: 150
    							},
    							{
    								Header: "Logged at",
    								accessor: "logged_at",
									Cell: row => (<div className="text-center">{moment(row.value).format("DD-MM-YYYY")}</div>),
									minWidth: 150
								  },{
    								Header: "Log type",
    								accessor: "log_type_name",
									Cell: row => (<div className="text-center">{row.value}</div>),
									minWidth: 150
								  },{
    								Header: "Created at",
    								accessor: "created_at",
									Cell: row => <div className="text-center">{moment(row.value).format("DD-MM-YYYY HH:mm")}</div>,
									minWidth: 150
    							}, {
    								Header: "Actions",
    								accessor: "id",
    								filterable: false,
    								sortable: false,
    								Cell: row => (
    									<div className="text-center">
    										<button title="Edit" onClick={() => this.handleEditLog(row.original)} className="btn-action material-icons btn-edit">edit</button>
    										<button title="Delete" onClick={() => this.logToDelete(row.original)} className="btn-action material-icons btn-delete">delete</button>
    									</div>
    								)
    							}
    						]}
    						manual 
    						data={data}
    						pages={pages} 
    						loading={isLoadingTable}
    						onFetchData={ debounce(this.getMyLogs, 400) } 
    						filterable
    						defaultSorted={[{ id: "created_at", desc: true }]}
    						defaultPageSize={20}
    						className="-highlight"
    					/>
    				</div>   
    			</div>
				<EditLoggedHoursModal 
					isEditingHours={isEditingHours}
					showEditModal={showEditModal}
					showDeleteBtn={false}
					selectedTask={selectedTask}
					selectedLogType={selectedLogType}
					selectedProject={selectedProject}
					selectedArea={selectedArea}
					directTask={directTask}
					projectName={projectName}
					status={status_id}
					minutes={minutes}
					hours={hours}
					errors={errors}
					formData={formData}
					logTypes={logTypes}
					closeEditModal={this.closeEditModal}
					logToDelete = {this.logToDelete} 
					onUpdateSubmit={this.onUpdateSubmit}
					onChange={this.onChange}
					onChangeHours={this.onChangeHours}
					onMinutesSelectChange={this.onMinutesSelectChange}
					onSelectChange={this.onSelectChange}
				/>
    			<DeleteModal
    				itemToDelete={logToDelete}
    				deleteItem={this.deleteLog}
    				isDeleting={isDeleting}
    				closeModal={this.closeModal}
    			/>
    		</div>
    	);
	}
}


export default MyLogsPage;



// WEBPACK FOOTER //
// ./src/components/pages/logged-hours/MyLogsPage.js